import ContentAdapter from 'rise-ui/adapters/apis/rise-api/content.js';

import { FetchOnce } from 'rise-ui/utils/adapter.js';

@FetchOnce()
export default class FieldAdapter extends ContentAdapter {
  pathForType() {
    return 'field_storage_config/field_storage_config';
  }
}
